import { MouseEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { followPlaceStep, PlaceStep, readPlaceSurface } from '../../utils/placeMotion';

interface BreadcrumbItem {
  label: string;
  to?: string;
  state?: unknown;
  step?: PlaceStep;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const surface = readPlaceSurface(location.state);

  return (
    <nav className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-gray-600 mb-6" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        
        return (
          <div key={index} className="flex items-center">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                state={item.state}
                onClick={(event) => {
                  item.onClick?.(event);
                  if (event.defaultPrevented || !item.step || !item.to) return;
                  followPlaceStep(event, item.step, item.to, navigate, location, surface);
                }}
                className="hover:text-primary transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-gray-900 font-medium' : ''}>
                {item.label}
              </span>
            )}
            {!isLast && (
              <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400" />
            )}
          </div>
        );
      })}
    </nav>
  );
}

